import React from 'react';
import { object, shape, string } from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';

import { withLabels } from 'containers/withLabels';
import { withCountryContext } from 'containers/withCountryContext';

import IconEye from 'media/icons/eye.icon.svg';
import styles from './ResourcesItem.module.scss';
const cx = classNames.bind(styles);

const ResourcesItem = ({
  item,
  labels,
  contextCountry: { currentCountry },
}) => (
  <div className={cx('row', { 'only-child': !item.short_description })}>
    <div className={cx('cell', 'cell-description')}>
      <h4 className={cx('title')}>
        <Link
          to={{
            pathname: item.alias,
            search: '?country=' + currentCountry,
            state: { historyExist: true },
          }}
          className={cx('title-link')}
        >
          {item.title}
        </Link>
      </h4>
      {!!item.short_description && (
        <p className={cx('text')}>{item.short_description}</p>
      )}
    </div>
    <div className={cx('cell', 'cell-btn')}>
      <Link
        to={{
          pathname: item.alias,
          search: '?country=' + currentCountry,
          state: { historyExist: true },
        }}
        className={cx('link')}
      >
        <span className={cx('btn-icon')}>
          <IconEye />
        </span>
        <span className={cx('btn-text')}>{labels.buttonDiscoverLabel}</span>
      </Link>
    </div>
  </div>
);

ResourcesItem.propTypes = {
  item: object.isRequired,
  labels: object.isRequired,
  contextCountry: shape({
    currentCountry: string.isRequired,
  }).isRequired,
};

export default withLabels(withCountryContext(ResourcesItem));



// WEBPACK FOOTER //
// ./src/pages/Product/components/TabResources/components/ResourcesItem/ResourcesItem.js